import React from 'react';
import { IncompleteIcon } from 'views/ActivityDataEntry/activityDataEntry.util';

interface ErrorIconProps {
  errorList: String[];
  stringToCheck: String;
}

const ErrorIcon = (props: ErrorIconProps) => {
  const { errorList, stringToCheck } = props;
  const tooltipMsg = 'Few fields are not filled properly';

  return errorList.includes(stringToCheck) ? (
    <IncompleteIcon msg={tooltipMsg} />
  ) : null;
};

export default ErrorIcon;
